import { getFirestore, doc, setDoc } from "firebase/firestore";
import { getAuth } from "firebase/auth";

export const markProgress = async (subjectKey, slug, field) => {
  const auth = getAuth();
  const user = auth.currentUser;

  if (!user?.uid || !subjectKey || !slug || !field) {
    console.error("User is not authenticated or required parameters are missing.");
    return;
  }

  const db = getFirestore();
  const userDataRef = doc(db, "userData", user.uid);

  try {
    await setDoc(
      userDataRef,
      {
        [subjectKey]: {
          [slug]: {
            [field]: true,
          },
        },
      },
      { merge: true }
    );
    console.log("Progress marked successfully!");
  } catch (error) {
    console.error("Error marking progress:", error.message);
  }
};

export default markProgress;